module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_c('van-tabs', {
    staticClass: "tabs_",
    attrs: {
      "line-height": "0"
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, _vm._l((_vm.content), function(item, i) {
    return _c('van-tab', {
      key: item.id,
      staticClass: "tab_"
    }, [_c('template', {
      slot: "title"
    }, [_c('div', {
      staticClass: "tagname"
    }, [_vm._v(_vm._s(item.tagname))]), _vm._v(" "), _c('div', {
      class: _vm.active == i ? 'sname-change flex-center' : 'sname'
    }, [_vm._v(_vm._s(item.sname))])]), _vm._v(" "), _c('goodsItem1', {
      attrs: {
        "goodsList": item.list
      }
    })], 2)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cfc2f81","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/GoodsTabs.vue
// module id = 2202
// module chunks = 0